import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import * as _ from 'lodash';


@Injectable({ providedIn: 'root' })
export class RedirectionGuard {
    constructor(
        private router: Router,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {

        if (_.includes(state.url, '/sector/') && _.includes(state.url, '/product/')) {
            this.router.navigateByUrl(`/product/${state.url.split("/product/")[1]}`)
        }
        else if (_.includes(state.url, '/sector/') && _.includes(state.url, '/category')) {
            this.router.navigateByUrl(`/category/${state.url.split("/category/")[1]}`)
        }

        else if (_.includes(state.url, '/sector/')) {
            this.router.navigateByUrl(`/category/${state.url.split("/sector/")[1]}`)
        }
       

        return true;

    }
}